import React, { useState } from "react";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { useNavigate, useLocation } from "react-router-dom";
import { AddNewBlogForm } from "../../../../components/parts/forms";
import { GET_API_URLS } from "../../../../utils/constant";
import { CardWrapper } from "../../../../components/wrapper";
import FormErrorPopup from "../../../../components/parts/popups/errorPopup";
import styles from "./style.module.scss";

const AddBlog = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const addNewBlogHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let k in data) {
      formData.append(k, data[k]);
    }

    jwtInterceoptor
      .post(GET_API_URLS.BLOG_URL, formData)
      .then((response) => {
        console.log(response.data);
        navigate("/dashboard/communityCare");
      })
      .catch((error) => {
        setLoading(false);
        setError(error.message);
        console.log("Error", error);
      });
  };

  const updateBlogHandler = (data) => {
    // console.log(GET_API_URLS.BLOG_URL+`${data.id}/`);
    setLoading(true);
    let formData = new FormData();
    for (let k in data) {
      if (k === "title" || k === "image" || k === "content") {
        formData.append(k, data[k]);
      }
    }

    jwtInterceoptor
      .patch(GET_API_URLS.BLOG_URL + `${data.id}/`, formData)
      .then((response) => {
        console.log(response.data);
        navigate("/dashboard/communityCare");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 403) {
          setError("You dont have permission to add blogs.");
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  return (
    <>
      <div className={styles.addBlogContainer}>
        <CardWrapper>
          <AddNewBlogForm
            updateData={updateBlogHandler}
            data={addNewBlogHandler}
            loading={loading}
            formInitialValues={location.state || null}
          />
        </CardWrapper>
      </div>
      {error && <FormErrorPopup error={error} close={() => setError(false)} />}
    </>
  );
};

export default AddBlog;
